/**
 * CodeType
 */
export enum CCodeType  {
  /**
   * CODE39
   */
  CODE39,
  /**
   * CODE128
   */
  CODE128,
  /**
   * CODE93
   */
  CODE93,
  /**
   * CODABAR
   */
  CODABAR,
  /**
   * EAN8
   */
  EAN8,
  /**
   * EAN13
   */
  EAN13,
  /**
   * UPCA
   */
  UPCA,
  /**
   * UPCE
   */
  UPCE,
  /**
   * I2OF5
   */
  I2OF5,



}


